import React from 'react'

const SendIcon = props => (
  <svg viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g mask="url(#mask0)">
      <path
        d="M8.96459 15.2978L6.95716 11.832C6.77926 11.5248 6.84685 11.1341 7.11829 10.8999L10.5333 7.95377C10.6848 7.82301 10.5401 7.57326 10.3508 7.63862L6.08361 9.11354C5.74449 9.23091 5.37115 9.09375 5.19335 8.78678L3.18582 5.32082C3.04284 5.07396 3.22472 4.7641 3.51225 4.76321L15.1509 4.71651C15.44 4.71471 15.6183 5.02248 15.4722 5.27114L9.61227 15.2948C9.46773 15.5425 9.10758 15.5446 8.96459 15.2978Z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default SendIcon
